export const TYPE_PROGRAM = 'programa'; 
export const TYPE_COURSE = 'curso'; 
export const TYPE_QUICKACCESS = 'acceso'; 